<template>
    [PR]
    <div ref="containerRef">
    <!-- Google AdSense コード -->
    <ins class="adsbygoogle" style="display:inline-block;width:728px;height:90px"
    data-ad-client="ca-pub-6336239615356624" data-ad-slot="7551554240"
    data-ad-format="auto" data-full-width-responsive="true">
    </ins>
  </div>
</template>

<script>
export default {
    name: "FooterAdsense",
    data(){
        return{
            containerRef:{}
        }
    },
    mounted(){
        this.containerRef = this.$refs.containerRef;
        
        const adsScript = document.createElement("script");
        adsScript.async = true;
        adsScript.crossOrigin = "anonymous";
        adsScript.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6336239615356624";

        const inlineScript = document.createElement("script");
        inlineScript.type = "text/javascript";
        inlineScript.text = `(adsbygoogle = window.adsbygoogle || []).push({});`;

        this.containerRef.appendChild(adsScript);
        this.containerRef.appendChild(inlineScript);
    },
    methods:{

    }
}
</script>

<style>

</style>